import { Injectable } from "@angular/core";

import { DataService } from "../shared/services/data.service";
import { ConfigurationService } from "../shared/services/configuration.service";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LoginSettingsDTO } from "../shared/dto-models/loginSettingsDTO.model";
import { LoginSettingsCommand } from "../shared/models/loginSettingsCommand";
import { SessionTimeout } from "../system-settings/user-policy/session-timeout";

@Injectable()
export class LoginSettingsService {
  private apiUrl = "";

  constructor(
    private service: DataService,
    private configurationService: ConfigurationService,
  ) {
    if (this.configurationService.isReady) {
      this.apiUrl = this.configurationService.serverSettings.userSettingsApiUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(
        (x) => (this.apiUrl = x?.userSettingsApiUrl),
      );
    }
  }

  get(): Observable<LoginSettingsDTO> {
    const url = `${this.apiUrl}/api/v1/loginsettings`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  save(command: LoginSettingsCommand): Observable<true> {
    const url = `${this.apiUrl}/api/v1/loginsettings/save`;

    return this.service.postWithId(url, command).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  getSessionTimeout(): Observable<SessionTimeout> {
    const url = `${this.apiUrl}/api/v1/loginsettings/getsessiontimeout`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  saveSessionTimeout(obj: SessionTimeout): Observable<true> {
    const url = `${this.apiUrl}/api/v1/loginsettings/saveSessionTimeout`;

    return this.service.postWithId(url, obj).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }
}
